export const getToday = () => new Date();

/**
 * Returns the long name of the month for the current locale
 * @param month the number of the month (zero based!)
 * @example March
 */
export const getMonthName = (month: number, locale: string) => {
  const date = new Date(Date.UTC(2020, month, 2));
  return date.toLocaleDateString(locale, { month: "long" });
};

/**
 * Return the 'narrow' names for every weekday starting with monday for the current locale
 * @example 'M,T,W,T,F,S,S'
 */
export const getWeekDays = (locale: string) => {
  var baseDate = new Date(Date.UTC(2017, 0, 2)); // pick a random monday
  var weekDays = [];
  for (let i = 0; i < 7; i++) {
    const fullName = baseDate.toLocaleDateString(locale, { weekday: "long" });
    const twoLetters = baseDate.toLocaleDateString(locale, { weekday: "long" }).slice(0, 2);
    const shortName = baseDate.toLocaleDateString(locale, { weekday: "narrow" });
    weekDays.push({ fullName, twoLetters, shortName });
    baseDate.setDate(baseDate.getDate() + 1);
  }

  return weekDays;
};

export const formatTime = (seconds: number) => {
  const exactHours = seconds / 3600;
  let roundedHours = Math.floor(exactHours);
  const exactMin = (exactHours - roundedHours) * 60;
  let roundedMin = Math.floor(exactMin);
  let roundedSec = Math.round((exactMin - roundedMin) * 60);
  if (roundedSec === 60) {
    roundedMin += 1;
    roundedSec = 0;
    if (roundedMin === 60) {
      roundedHours += 1;
      roundedMin = 0;
    }
  }
  // eslint-disable-next-line prettier/prettier
  return `${roundedHours !== 0 ? `${roundedHours}:` : ""}${
    roundedHours ? `0${roundedMin}`.slice(-2) : roundedMin
  }:${`0${roundedSec}`.slice(-2)}`;
};

export const formatDuration = (totNumberMin: number) => {
  if (typeof totNumberMin !== "number") {
    return null;
  }

  const numHours = Math.floor(totNumberMin / 60);
  const numMin = totNumberMin % 60;

  return `${numHours}:${numMin < 10 ? `0${numMin}` : numMin}`;
};

export const formatTimeMilis = (milis: number) => {
  const date = new Date(milis);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  return `${hours}:${minutes < 10 ? `0${minutes}` : minutes}`;
};
